import { render, staticRenderFns } from "./TabbedPane.vue?vue&type=template&id=7ac19b3c&scoped=true&"
import script from "./TabbedPane.vue?vue&type=script&lang=js&"
export * from "./TabbedPane.vue?vue&type=script&lang=js&"
import style0 from "./TabbedPane.vue?vue&type=style&index=0&id=7ac19b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac19b3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VSheet,VTab,VTabs,VToolbar})
